module.exports = __webpack_public_path__ + "img/Classic.5ac16486.jpeg";